import securityEAComponents from "../../../../../../web-sh/src/pages/admin/settings/components/security/emergency-access";

import EAHeader from "./Header";

securityEAComponents.EAHeader = EAHeader;

export default securityEAComponents;